import * as XLSX from 'xlsx';

export default function exportSprintDataToExcel(sprintData: any[], projectName: string) {
    const workbook = XLSX.utils.book_new();

    // set up the column headers
    const headers = [
        "Project",
        "Date",
        "Data Version ID",
        "Due to Start",
        "Due to Finish",
        "Actual Start",
        "Actual Finish",
        "Sprint Started Ahead",
        "Sprint Finished Ahead",
        "Unplanned Started Ahead",
        "Unplanned Finished Ahead",
        "Unplanned Started",
        "Unplanned Finished",
        "Incomplete Start",
        "Incomplete Finish"
    ];

    // Map sprint data to worksheet format
    const worksheetData = [
        headers,
        ...sprintData.map(item => [
            projectName,
            item.date,
            item.dataVersionId,
            item.dueToStart,
            item.dueToFinish,
            item.actualStart,
            item.actualFinish,
            item.sprintStartedAhead,
            item.sprintFinishedAhead,
            item.unplannedStartedAhead,
            item.unplannedFinishedAhead,
            item.unplannedStarted,
            item.unplannedFinished,
            item.incompleteStart,
            item.incompleteFinish
        ])
    ];

    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sprint Data');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `${projectName}_Sprint_Data.xlsx`);
}